export class AppFileInput extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.render();
    }

    static get observedAttributes() {
        return ['label', 'formControlName', 'placeholder', 'button-text', 'accept', 'multiple'];
    }

    attributeChangedCallback(name: string, oldValue: string, newValue: string) {
        if (oldValue !== newValue && this.innerHTML !== '') {
            this.render();
        }
    }

    render() {
        const label = this.getAttribute("label") || "";
        const controlName = this.getAttribute("formControlName") || "";
        const placeholder = this.getAttribute("placeholder") || "Seleccionar archivo...";
        const buttonText = this.getAttribute("button-text") || "SUBIR FOTO";
        const accept = this.getAttribute("accept") || "image/*";
        const multiple = this.hasAttribute("multiple");

        const labelHtml = (label && label.trim() !== "" && label !== "&nbsp;") 
            ? `<label class="form-label">${label}</label>` 
            : "";

        this.innerHTML = `
            ${labelHtml}
            <div class="grid grid-cols-1 md:flex items-center gap-4">
                <button type="button" class="bg-[#cccccc] hover:bg-[#bbbbbb] text-[#333333] font-semibold text-sm px-5 py-2.5 rounded-[0.4rem] transition-colors duration-150 shrink-0 mx-6 md:mx-auto">
                    ${buttonText}
                </button>
                <input type="text" readonly placeholder="${placeholder}" class="flex-grow bg-white rounded-[0.4rem] px-4 py-2.5 text-slate-800 italic placeholder-slate-400 text-sm outline-none" />
                <input ${controlName ? `formControlName="${controlName}"` : ''} type="file" accept="${accept}" ${multiple ? 'multiple' : ''} class="hidden" />
            </div>
            ${controlName ? `<span formErrorFor="${controlName}" class="text-red-600 text-xs font-medium block min-h-[1.25rem] px-1 transition-all duration-150"></span>` : ''}
        `;
    }
}

if (typeof window !== 'undefined') {
    customElements.define('app-file-input', AppFileInput);
}
